import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../contexts/AuthCtx";

export default function AuthGuard({ children }) {
    const authCtx = useAuth();
    const navigateTo = useNavigate();
    const location = useLocation();

    const [page, setPage] = useState("loading");

    useEffect(() => {
        
        if(authCtx.initialized) {

            if(authCtx.authenciated) {
                navigateTo('/app');
            }
            else if(authCtx.authenciated !== null && authCtx.authenciated === false) {
                setPage("landing");
            }
        }

    }, [authCtx.initialized, authCtx.authenciated]);

    if(page === "loading") {
        return <h1>Loading...</h1>
    }
    else if(page === "landing")
    {
        return children;
    }

}  